import emojiRegex from 'emoji-regex';

const skinTones = ['', '-1f3fb', '-1f3fc', '-1f3fd', '-1f3fe', '-1f3ff'];

export function getIndexOfSkinTone(input) {
  return skinTones.findIndex((tone) => input.indexOf(tone) > 0) + 1;
}

export function emojiFromString(stringInput) {
  if (stringInput) {
    const regex = emojiRegex();
    const input = stringInput.replace('U+', '');
    const inputArr = input
      .split('-')
      .map((item) => item.trim())
      .filter(Boolean)
      .map((item) => Number.parseInt(item, 16));

    if (!inputArr.length || inputArr.some((item) => Number.isNaN(item))) {
      return null;
    }

    let skinToneIndex = 0;
    if (inputArr.length > 1) {
      skinToneIndex = getIndexOfSkinTone(input);
    }

    try {
      const emoji = String.fromCodePoint(...inputArr);
      return emoji.match(regex) ? { emoji, skinToneIndex } : null;
    } catch {
      return null;
    }
  }
  return null;
}

// Keep an off-scale target from flattening the spending bars. Negative-only data already has zero
// at the top of its axis, while an empty chart uses the shared bar chart's explicit 0..1 range.
// The latter therefore has to pin to 1 rather than 0 or the target lands on the baseline.
export function computeTargetOverflow(targetAmount, chartData) {
  const target = targetAmount != null ? Math.abs(targetAmount) : null;
  if (target == null || target === 0) {
    return null;
  }

  const values = (chartData || []).map((row) => Number(row?.total) || 0);
  const tallestBar = values.reduce((tallest, value) => Math.max(tallest, value), 0);
  if (tallestBar > 0) {
    if (target <= tallestBar) {
      return null;
    }
    const magnitude = 10 ** Math.floor(Math.log10(tallestBar));
    const roundedCeiling = Math.ceil(tallestBar / magnitude) * magnitude;
    const ceiling = roundedCeiling > tallestBar ? roundedCeiling : roundedCeiling * 1.1;

    return { ceiling, pinAxis: true };
  }

  const hasInflow = values.some((value) => value < 0);
  return hasInflow ? { ceiling: 0, pinAxis: false } : { ceiling: 1, pinAxis: true };
}

/**
 * Only exactly one day reads "Day left"; 0 and every other count stay plural. An absent countdown
 * has no label so callers can hide the entire metric when the watchlist has no end date.
 */
export function getDaysLeftLabel(daysLeft) {
  if (daysLeft == null) return null;
  return daysLeft === 1 ? 'Day left' : 'Days left';
}

export function createFilterData(selectedType, selected) {
  // Create Filter
  switch (selectedType) {
    case 'tags':
      return selected.map((id) => ({ id })).toArray();
    case 'payeeNames':
      return selected.toArray();
    case 'categories':
      return selected
        .toArray()
        .map((item) =>
          item === 'UNCATEGORIZED' || item === '0'
            ? { id: '0', type: 'UNCATEGORIZED' }
            : { id: item, type: 'CATEGORY' },
        );
    default:
      return null;
  }
}
